<template>
  <div
    v-if="productImage || withPlaceholder"
    :class="`product-item-photo${isFromList ? ' col-sm-2' : ''}${
      productImage ? '' : ' product-item-photo--placeholder'
    }`"
  >
    <a v-if="productImage" :href="product.url" class="product-image-link">
      <img
        class="img-fluid product-image"
        :src="productImage"
        :alt="imageAlt"
      />
    </a>
    <span v-else class="product-image-placeholder" aria-hidden="true">
      <!-- Placeholder neutre : icone "produit" generique en SVG inline,
           taille fluide via viewBox. Pas de fetch reseau. -->
      <svg viewBox="0 0 48 48" width="100%" height="100%">
        <rect
          x="6"
          y="10"
          width="36"
          height="30"
          rx="3"
          ry="3"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        />
        <path
          d="M6 32 L18 22 L26 28 L36 16 L42 22 L42 40 L6 40 Z"
          fill="currentColor"
          opacity="0.18"
        />
        <circle cx="16" cy="18" r="2.5" fill="currentColor" opacity="0.5" />
      </svg>
    </span>
  </div>
</template>

<script>
import ChoiceImage from "@/services/choiceImage";

export default {
  name: "ProductListImage",
  props: {
    product: {
      type: Object,
      required: true,
    },
    isFromList: {
      type: Boolean,
      default: false,
    },
    isProductListFromParent: {
      type: Boolean,
      default: false,
    },
    /**
     * Si true, le wrapper `.product-item-photo` est toujours rendu : un
     * placeholder neutre (icone produit generique) s'affiche quand le
     * produit n'a pas d'image. Utilise par OrderPage.vue pour reserver un
     * emplacement image carre sur chaque offre, qu'il y ait ou non un
     * visuel configure.
     */
    withPlaceholder: {
      type: Boolean,
      default: false,
    },
    alt: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    imageAlt() {
      if (this.alt !== undefined && this.alt !== null) return this.alt;
      return this.product?.name || "";
    },
    productImage() {
      return (
        ChoiceImage.getChoiceImageSrc(this.product, window.productDetails, {
          isProductListFromParent: this.isProductListFromParent,
        }) || null
      );
    },
  },
};
</script>

<style scoped>
/* FORGE-308: le wrapper <a> conserve la zone cliquable (UX/accessibilité)
   mais on neutralise le padding/margin que Bootstrap applique par défaut
   aux liens dans une colonne (cause du gap autour de l'image cross-sell). */
.product-image-link {
  display: block;
  padding: 0;
  margin: 0;
  line-height: 0;
}
.product-image-link .product-image {
  display: block;
}

/* FORGE-391: ecart entre la photo produit et les details texte sur les order
   pages. On utilise margin-right (et non padding-right) pour ne pas etre
   ecrase par les regles CSS marketing presentes sur certaines order pages
   (ex: ".order-page-process .product-item-info > * { padding: 5px }").
   La marge cree un espace entre les divs voisins, le padding ne le fait pas.
   Scope volontairement restreint a .order-page-process pour ne pas affecter
   les autres listes produits (cart, catalogue) qui utilisent aussi Image.vue.
   Limite au desktop : sur mobile la card s'empile en colonne et la marge
   horizontale est sans effet visuel. */
@media (min-width: 992px) {
  .order-page-process .product-item-photo {
    margin-right: 16px;
  }
}
</style>
